// utils/env.js
const ua = navigator.userAgent.toLowerCase();

export const isDingTalk = () => {
  return ua.indexOf('dingtalk') > -1;
};

export const isWeCom = () => {
  return ua.indexOf('wxwork') > -1;
};

export const isWeChat = () => {
  // 微信环境包含 wxwork，所以要排除 wxwork 才是纯公众号
  return ua.indexOf('micromessenger') > -1 && !isWeCom();
};

export const getPlatform = () => {
  if (isDingTalk()) return 'DINGTALK';
  if (isWeCom()) return 'WECOM';
  if (isWeChat()) return 'WECHAT';
  return 'BROWSER';
};